<template>
  <v-container class="pt-0 pb-0" v-if="menus">
    <v-row justify="center" v-for="(menu, i) in menus" :key="i">
      <v-col>
        <v-row align="center">
          <v-col cols="2" class="pa-0">
            <v-avatar size="60" tile>
              <ImgWrapper :src="menu.t_image_url" v-if="menu.t_image_url" />
              <ImgWrapper :src="noimageUrl" v-else />
            </v-avatar>
          </v-col>
          <v-col cols="7" class="text-h6">{{ menu.name }}</v-col>
          <v-col cols="3" class="pt-0 pb-0" align="right">
            <span v-if="!orderVersionInvalid" class="text-subtitle-1"
              >￥{{ menu.amountBaseEx }}</span
            >
          </v-col>
        </v-row>

        <template v-if="orderVersionInvalid">
          <v-row>
            <v-spacer />
            <v-col cols="10"
              >メニューが変更されているため、詳細を表示できません</v-col
            >
          </v-row>
        </template>
        <template v-if="!orderVersionInvalid">
          <v-row
            v-for="(topping, j) in toppingsData(menu.toppings)"
            :key="j"
            align="center"
          >
            <v-spacer />
            <v-col cols="7" class="pt-0 pb-0">
              <span class="text-subtitle-2"
                >{{ topping.title }} ({{ topping.name }})
              </span>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0" align="right">
              <span class="text-subtitle-1">￥{{ topping.amount }}</span>
            </v-col>
          </v-row>
          <v-row align="center">
            <v-spacer />
            <v-col cols="7" class="pt-0 pb-0">
              <span class="text-subtitle-2">数量</span>
            </v-col>
            <v-col cols="3" class="pt-0 pb-0" align="right">
              <span class="text-subtitle-1">{{ menu.count }}</span>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-spacer />
            <v-col cols="5" class="text-h5" align="right">
              ￥{{ amountMenu(menu) | addComma }}
            </v-col>
          </v-row>
          <v-row v-show="showReOrder">
            <v-spacer />
            <v-col cols="auto">
              <v-btn large tile text outlined @click="orderAgain(menu)"
                >もう一度注文する</v-btn
              >
            </v-col>
          </v-row>
        </template>

        <v-divider class="mt-4" />
      </v-col>
    </v-row>

    <!-- 金額 -->
    <v-container
      v-show="menus.length != 0 && !orderVersionInvalid"
      class="pt-0"
    >
      <v-row justify="end" class="pt-0" align="baseline">
        <v-col cols="4">
          <span class="text-h5">合計</span>
        </v-col>
        <v-col cols="8" class="pr-0" align="right">
          <span class="text-h4">￥</span
          ><span class="text-h3">{{ totalData.prices | addComma }}</span>
        </v-col>
      </v-row>
      <v-row justify="end" v-show="totalData.pricesTax10 > 0">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 10%対象 ￥</span>
          <span class="text-h7">{{ totalData.pricesTax10 | addComma }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
      <v-row justify="end" v-show="totalData.pricesTax8 > 0">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 8%軽減対象 ￥</span>
          <span class="text-h7">{{ totalData.pricesTax8 | addComma }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-col cols="auto" class="pt-0 pr-0">
          <span class="text-h7">( 内消費税等 ￥</span>
          <span class="text-h7">{{ totalData.taxTotal | addComma }}</span>
          <span class="text-h7"> )</span>
        </v-col>
      </v-row>
    </v-container>

    <!-- sheet エラー(共通) -->
    <v-bottom-sheet v-model="showErrorCmnSheet">
      <v-sheet class="text-center">
        <v-container class="line-bg">
          <v-row>
            <v-col>
              <Bubble
                question=""
                :content="errorSheetCmnText"
                :border-content="false"
              />
            </v-col>
          </v-row>

          <!-- 下部固定 -->
          <div style="align: center; width: 100%">
            <v-btn x-large text @click="showErrorCmnSheet = !showErrorCmnSheet"
              ><span class="text-decoration-underline white--text"
                >とじる</span
              ></v-btn
            >
          </div>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Bubble from "./Bubble";
import { calculate } from "../../util/calculate";
import { MSG_HISTORY } from "../../constants/messages";

const IMAGE_DEFAULT = require("@/assets/noimage.png");
import { CART_ITEM } from "../../util/order_util";

// 画面種類
const MODE_HISTORY_DETAIL = 0; // 注文履歴(詳細)
// const MODE_ORDER_DETAIL = 1; // 注文情報(詳細)

export default {
  components: {
    Bubble,
    ImgWrapper: () => import("./ImgWrapper"),
  },
  props: {
    mode: Number, //0:注文履歴(詳細) 1:注文情報
    order: Object,
    showReOrder: Boolean,
    // borderContent: { type: Boolean, default: true },
  },

  data: () => ({
    menus: [],
    noimageUrl: IMAGE_DEFAULT,
    totalData: {
      prices: 0,
      pricesTax10: 0,
      pricesTax8: 0,
      taxTotal: 0,
    },
    showErrorCmnSheet: false,
    errorSheetCmnText: "",

    // 注文バージョンID 比較
    orderVersionInvalid: false,
  }),
  created() {
    this.styleContent = this.borderContent ? "says-border" : "says";
  },
  async mounted() {
    this.showProgress();
    try {
      // 注文バージョンID 比較 (過去 version 注文は追加不可)
      if (this.mode === MODE_HISTORY_DETAIL) {
        const orderVersionId = this.order.orderVersionId;
        const compareVersionResult = await this.compareOrderVersionId({
          orderVersionId,
        });
        this.orderVersionInvalid = !compareVersionResult;
      }
      this.bindData();
    } finally {
      this.hideProgress();
    }
  },
  computed: {
    ...mapGetters(["progress"]),

    //-------------------------
    // Cart.vue と同一
    //-------------------------
    toppingsData: function () {
      return function (toppings) {
        return this.createToppingsViewData(toppings);
      };
    },
    amountMenu: function () {
      return function (menu) {
        return this.calculateMenuAmount(menu);
      };
    },
  },
  methods: {
    ...mapActions([
      "showProgress",
      "hideProgress",
      "compareOrderVersionId",
      "compareWithLatestMenu",
    ]),
    bindData: function () {
      // メニュー内のトッピングをソート (bind 後に行うとエラー)
      const sortedMenus = this.order.menus.map((menu) => {
        const toppingsSorted = menu.toppings.sort(
          (t1, t2) => t1.sort - t2.sort
        );
        const menuNew = menu;
        menuNew.toppings = toppingsSorted;
        return menuNew;
      });

      // bind
      this.menus = sortedMenus;

      // 設定(消費税関係) --> 購入時点の設定
      const taxSettings = this.order.settings.consumptionTax;

      // 合計金額
      this.totalData = calculate.createTotalData(taxSettings, sortedMenus);
      // console.log("totalData", this.totalData);
    },
    //-------------------------
    // Cart.vue と同一
    //-------------------------
    createToppingsViewData: function (toppings) {
      // 表示用に加工
      var viewData = [];

      // selected されているトッピングのみ羅列する
      toppings.forEach((topping) => {
        const selected = topping.selected;
        topping.values
          .filter((value) => value.id == selected)
          .forEach((value) => {
            value.title = topping.name;
            viewData.push(value);
          });
      });
      // console.log("view", viewData);

      return viewData;
    },
    calculateMenuAmount: function (menu) {
      return calculate.calcMenuPrice(menu);
    },
    orderAgain: async function (menu) {
      console.log("orderAgain", menu);

      // 事前チェック
      const checkResult = await this.checkBeforeOrderAgain(menu);
      console.log("orderAgain", checkResult);
      if (!checkResult.result) {
        this.errorSheetCmnText = checkResult.msg;
        this.showErrorCmnSheet = !this.showErrorCmnSheet;
        return;
      }

      // 画面遷移(メニュー 詳細)
      const orderId = this.order.orderId;
      this.$router.push({
        name: "Menu",
        params: { id: menu.menuId },
        query: {
          from: "history",
          orderId: orderId,
          orderMenuId: menu.orderMenuId,
        },
      });
    },
    checkBeforeOrderAgain: async function (menu) {
      // メニュー最新値(/menus) と比較
      const compareResult = await this.compareWithLatestMenu({ menu });
      const result = compareResult === CART_ITEM.OK;
      const msg = !result ? this.createSheetErrMsg(compareResult) : null;
      return {
        result: result,
        msg: msg,
      };
    },
    createSheetErrMsg: function (itemType) {
      if (itemType === CART_ITEM.UPDATED) {
        return MSG_HISTORY.CHANGED;
      } else if (itemType === CART_ITEM.DELETED) {
        return MSG_HISTORY.DELETED;
      }
      throw Error(`not implemented: ${itemType}`);
    },
  },
};
</script>

<style>
@import "../../css/bubble.css";
</style>
